import React, { Component } from 'react';
import { css } from 'aphrodite';

import { ReportBox, Font, Text, Flexbox, ColorEnvironment } from './Styles';

import Image from './Image';
import ButtonSet from './ButtonSet';

import Locale from './models/Locale';

class HazardInfo extends Component {
  render() {
    let actions = [[Locale.localized("OK"), this.props.onClose]];
    return(
      <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter, ReportBox.container, ColorEnvironment.normal)}>
          <Image extraStyles={ReportBox.topImageInverted} filename={this.props.hazard.iconFilename} />
          <div className={css(Font.heading, Text.heading)}>{this.props.hazard.hazard}</div>
          <div className={css(Flexbox.grow, Font.body, Text.textBlock)}>
            <p>{this.props.hazard.hazardDescription}</p>
          </div>
          <ButtonSet buttons={actions} />
        </div>
      </div>
    );
  }
}

export default HazardInfo;



// WEBPACK FOOTER //
// ./src/HazardInfo.js